import angular from 'angular';
import { includes } from 'lodash';

const DISPLAY_MODES = [
  'logos-only',
  'expanded'
];

module.exports = angular.module('common.directives.od-press', [])
.directive('odPress', () => {
  return {
    restrict: 'E',
    scope: {
      mode: '@?'
    },
    templateUrl: '/templates/common/directives/od-press.html',
    bindToController: true,
    controllerAs: 'odPressCtrl',
    controller: class {
      constructor() {
        if (!includes(DISPLAY_MODES, this.mode)) {
          this.mode = 'expanded';
        }
      }
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/od-press.js
 **/